import { makeStyles } from "tss-react/mui";
export const useProjectSelectorStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    gap: 33,
    color: "var(--color-main)",
    minWidth: 1072,
    padding: "45px 48px 0 56px",
  },
  modificationRoot: {
    minWidth: 1120,
    gap: 24,
    padding: "24px 24px 0 24px",
  },
  projects: {
    width: "70%",
    flexDirection: "column",
    display: "flex",
    height: "100%",
  },
  versions: {
    width: "30%",
    marginTop: 49,
  },
  modifications: {
    width: "40%",
    marginTop: 49,
  },
  searchBar: {
    width: "100%",
  },
  list: {
    marginTop: 13,
    backgroundColor: "var(--bg-secondary-light)",
    padding: "12px 8px 8px 25px",
    borderRadius: 4,
    position: "relative",
  },
  extraList: {
    marginTop: 0,
    padding: "12px 8px 8px 12px",
    minHeight: "100%",
    overflow: "hidden",
  },
  spinner: {
    position: "absolute",
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
    margin: "auto",
  },
  sortHeader: {
    color: "var(--main-text-color)",
    fontSize: 14,
    cursor: "pointer",
    paddingLeft: 10,
    userSelect: "none",
  },
  sortIcon: {
    fontSize: 13,
    marginLeft: 4,
  },
  btnBack: {
    cursor: "pointer",
    marginRight: 16,
    lineHeight: "normal",
  },
  title: {
    display: "flex",
    alignItems: "center",
    marginTop: 24,
    fontSize: theme.typography.pxToRem(24),
    fontWeight: 600,
  },
  listItem: {
    cursor: "pointer",
    fontSize: 16,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "var(--bg-blue-light-hover)",
    },
    paddingLeft: 10,
    display: "flex",
    alignItems: "center",
  },
  itemSelected: {
    backgroundColor: "var(--bg-blue-light)",
    borderRadius: 4,
    fontWeight: 600,
  },
  actions: {
    padding: "24px 0px",
    display: "flex",
    justifyContent: "center",
    gap: 40,
    width: "100%",
  },
  search: {
    height: 32,
    "& input": {
      padding: "8px 14px",
    },
  },
  latestLabel: {
    backgroundColor: "var(--color-primary)",
    fontSize: theme.typography.pxToRem(12),
    color: "var(--color-secondary)",
    borderRadius: 4,
    width: 48,
    height: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: 32,
    fontWeight: 300,
  },
}));
